/**
 * Add Organization to Events Page
 *
 * System Settings screen for adding one organization to many events in a single
 * action. The search and the event selection each have their own URL, so
 * reload and the back button work; a finished add is reported in a snackbar
 * on the selection step so more events can be added straight away. Each event
 * campaign is created by core exactly as ticking the organization on the event
 * would.
 */

import React from 'react';
import { useParams } from 'react-router-dom';
import { Translate } from 'react-redux-i18n';
import { i18nKeys } from './constants';
import { parseOrganizationId } from './helpers';
import OrganizationSearch from './components/OrganizationSearch';
import OrganizationStep from './components/OrganizationStep';
import styles from './AddOrganizationToEvents.module.css';

const AddOrganizationToEvents: React.FC = () => {
  const { organizationId } = useParams();

  if (organizationId !== undefined) {
    return (
      <div className={styles.container}>
        <OrganizationStep
          organizationId={parseOrganizationId(organizationId)}
        />
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <h2>
        <Translate value={i18nKeys.TITLE} />
      </h2>
      <p>
        <Translate value={i18nKeys.DESCRIPTION} />
      </p>
      <OrganizationSearch />
    </div>
  );
};

export default AddOrganizationToEvents;
